export enum TimeFormatEnum {
    ISO,
    AMPM,
}
